import { BriefType } from "src/slices/brief/types";

const generateOutlineSection = (brief: BriefType) => {
  if (!brief.selectedOutlines) {
    return "";
  }
  return `${brief.selectedOutlines
    .map((outline) => {
      if (["H2", "H3", "H4", "A"].includes(outline.tag)) {
        return `<${outline.tag.toLowerCase()}>${outline.text
          }</${outline.tag.toLowerCase()}><span style="font-size:0.8em">${outline.urls?.length > 0 ? " links: " + outline.urls.join(", ") : ""
          }</span><br/>`;
      }
      return `<ul><li>${outline.text}<span style="font-size:0.8em">${outline.urls?.length > 0 ? " links: " + outline.urls.join(", ") : ""
        }</span><br/></li></ul>`;
    })
    .join("")}`;
};
const formatStatistics = (statistics) => {
  if (statistics.length === 0) {
    return "";
  }
  return `Potential Statistics & Quotes to use in the article:
  <ol>${statistics.map((stat) => {
    //remove comma in fpr and double quotes from the statistics line
    const statistics_line = stat?.statistics?.replace(/["',]+/g, "").trim();

    return `<li><a href=${stat?.href}>${statistics_line}</a></li>`;
  }).join("")}</ol>
   ******************<br><br>
  `;
}

const formatCompanyDetails = (companyDetails) => {
  if (!companyDetails) {
    return "";
  }
  return `<span style="background-color: rgb(255, 255, 255);"><b>Company Details:</b></br>
  <ul>
  <li>Company Name: ${companyDetails?.companyName}</li>
  <li>Company Information: ${companyDetails?.companyInformation}</li>
  <li>Product Information: ${companyDetails?.productInformation}</li>
  <li>Target Audience: ${companyDetails?.targetAudience}</li>
  </ul>
  ******************<br>
  `;
}

const formatInsights = (insights) => {
  if (!insights) {
    return "";
  }
  let insightsData = insights.split("\n");
  insightsData = insightsData.filter((item) => item.trim() !== "");
  if (insightsData.length === 0) {
    return "";
  }
  insightsData = insightsData.map((item) => {
    return `<ul><li>${item}</li></ul>`;
  }
  );
  return `<span style="background-color: rgb(255, 255, 255);"><b>Custom Insights:</b></br></span>
  ${insightsData.join("")}
  ******************<br>


  `;
}






export const generateBriefText = ({ brief }: { brief: BriefType }, { projectData }) => {
  const sortedKeywords = [...brief.selectedTopics].sort(
    (a, b) => b.searchVolume - a.searchVolume
  );

  const clusteredKeywords = sortedKeywords.reduce((pV, cV) => {
    const clusterIndex = pV.findIndex((item) => item.cluster === cV.cluster);
    if (clusterIndex >= 0) {
      pV[clusterIndex].topics.push(cV);
    } else {
      pV.push({ cluster: cV.cluster ?? -1, topics: [cV] });
    }
    return pV;
  }, []);

  return `

    <h1><span style="background-color: rgb(255, 255, 255);">${brief.title
    }</span></h1>
    <span style="background-color: rgb(255, 255, 255);"><b>SEO title:</b><br>
    ${brief.title}</span><br><br>
    <span style="background-color: rgb(255, 255, 255);"><b>Meta description:</b></br>
    ${brief.description}</span><br><br>
    <span style="background-color: rgb(255, 255, 255); font-weight: 400">******************<br>
        <b>Article guidelines:</b><br>
        Focus keyword: ${brief.keyword} (SV: ${brief.mainKeywordSearchVolume ?? "n/a"
    })</br>
        Secondary keywords:</br>
        <ul>
        ${clusteredKeywords
      .map(
        ({ topics }) =>
          `<li>${topics.map(
            (topic) => ` ${topic.keyword} (SV: ${topic.searchVolume})`
          )}</li>`
      )
      .join("")}
        </ul></br>
        Suggested article length: ${brief.wordCount} words</br>
        Suggested number of headings: ${brief.headings}<br>
        Suggested number of words per heading: up to 250-350<br>
        Suggested number of images/media: ${brief.images}<br><br>
        ******************<br>
        <span style="background-color: rgb(255, 255, 255);"><b>Brand Voice:</b></span><br><br>
        ${projectData?.brandVoice}<br><br>
        ${brief?.companyDetails ? formatCompanyDetails(projectData?.companyDetails ?? {}) : ""}
       ${brief?.aiResearchAgent ? formatStatistics(brief.statistics ?? []) : ""}
       ${brief?.insights ? formatInsights(brief.insights) : ""}
        <b>Article outline:</b>
        ${generateOutlineSection(brief)}
        <br>******************

    </span>
    <br>
    This brief was created with <a href="https://seowind.io/">SEOwind.io</a>
  `;
};
